// Logo da empresa no centro da página inicial (enviado em Configurações); o do topo é sempre o do sistema.
// Ver EmpresaLogoService no back.
//
// GET    /empresas/minha/aparencia  -> { temLogo, versao, ajuste }
// PUT    /empresas/minha/aparencia  { modo, zoom, posX, posY, corFundo }  (só gerente; ver logoAjuste.js)
// GET    /empresas/minha/logo?v=    -> a imagem (precisa do token, por isso vira blob/objectURL); o v= é a versão
//                                       do logo, para o navegador guardar e só baixar de novo quando ele mudar
// POST   /empresas/minha/logo       (file)   (só gerente)
// DELETE /empresas/minha/logo                (só gerente)
import axios from 'axios';
import config from '../config/config';
import { normalizarAjuste } from './logoAjuste';

export const TIPOS_LOGO = ['image/png', 'image/jpeg'];
export const LOGO_MAXIMO_MB = 10;

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` } });

// { temLogo, url, ajuste } — url é um objectURL (revogar com URL.revokeObjectURL quando trocar/sair)
export async function carregarLogoEmpresa() {
  const { API_BASE_URL } = config;
  const { data } = await axios.get(`${API_BASE_URL}/empresas/minha/aparencia`, auth());
  let url = null;
  if (data?.temLogo) {
    const versao = encodeURIComponent(data.versao || '');
    const imagem = await axios.get(`${API_BASE_URL}/empresas/minha/logo?v=${versao}`, { ...auth(), responseType: 'blob' });
    url = URL.createObjectURL(imagem.data);
  }
  return { temLogo: !!data?.temLogo, url, ajuste: normalizarAjuste(data?.ajuste) };
}

export async function salvarAjusteLogo(ajuste) {
  const { API_BASE_URL } = config;
  const { data } = await axios.put(`${API_BASE_URL}/empresas/minha/aparencia`, normalizarAjuste(ajuste), auth());
  return normalizarAjuste(data?.ajuste);
}
